module.exports = __webpack_public_path__ + "static/media/ingredients.a8131865.png";